// Day.js-backed drop-in for the small slice of the moment API this app uses:
// moment(value) and moment.utc(value), plus the usual instance methods
// (.format/.isValid/.add/...). daterangepicker and the Search feature keep REAL
// moment via webpack.config.js (NormalModuleReplacementPlugin); this shim only
// covers app code, so moment stays off the critical path.
var dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

// ASP.NET / Web API serializes dates as "/Date(1583712000000)/". moment parses
// that format natively; Day.js does not (it returns an Invalid Date). Normalize
// it to an epoch-ms number before handing the value to Day.js so existing date
// fields keep rendering instead of showing "Invalid date".
var ASP_NET_DATE = /\/Date\((-?\d+)/;
function normalize(value) {
    if (typeof value === 'string') {
        var match = ASP_NET_DATE.exec(value);
        if (match) {
            return Number(match[1]);
        }
    }
    return value;
}

function moment() {
    var args = Array.prototype.slice.call(arguments);
    if (args.length) {
        args[0] = normalize(args[0]);
    }
    return dayjs.apply(null, args);
}

moment.utc = function () {
    var args = Array.prototype.slice.call(arguments);
    if (args.length) {
        args[0] = normalize(args[0]);
    }
    return dayjs.utc.apply(dayjs, args);
};

// Pass through the occasional helper so the shim reads like moment where used.
moment.isDayjs = dayjs.isDayjs;

module.exports = moment;
